import { requiredFieldValidator } from './requiredFieldVaildator';

interface EmailValidator {
  (email: string): boolean;
}

export const emailValidator: EmailValidator = (email) => {
  const isRequired = requiredFieldValidator(email);
  if (!isRequired) {
    return false;
  }
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email
  );
};
